import React, { useEffect, useState } from 'react';
import { Alert, Modal, Box, ButtonGroup, Button, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import Styles from '../../../common/styles/styles';
import { validateCategory, validateParameter, validateSetting } from '../../../common/utils/validationUtil';

export default function SettingsModal({ setting, onTriggerCreate, onTriggerUpdate }) {
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState({});  
  const [title, setTitle] = useState('');

  const isFormValid = Object.values(errors).filter(value => value !=='').length > 0;

  const handleOpen = () => {
    setOpen(true);
    setTitle('Create Setting');
  }

  const handleEditOpen = () => {
    setOpen(true);
    setTitle('Update Setting');
  }

  const handleClose = () => setOpen(false);

  const handleUpdate = async (event) => {
      await createSetting(event);
      setOpen(false);
      if (formData.id === '') {
          onTriggerCreate(formData.category);      
      } else {  
          onTriggerUpdate(formData.category);      
      }
  }

  const [formData, setFormData] = useState({
        id: '',
        category: '',
        parameter: '',
        setting: '',
        human_edit: false,
        phen_edit: false
  })

  const handleInputChange = (field) => (event) => {
      const value = event.target.value;
      setFormData({ ...formData, [field]: value });
    
      const newErrors = { ...errors };
    
      if (field === 'category') newErrors.category = validateCategory(value);
      if (field === 'parameter') newErrors.parameter = validateParameter(value);
      if (field === 'setting') newErrors.setting = validateSetting(value);
    
      setErrors(newErrors);
  }
  
  const options = [
    { value: true, label: 'True' },
    { value: false, label: 'False' }
  ]
  
  const createSetting = async (event) => {

    try {
        event.preventDefault();
        if (formData.id === '') {
            const response = await fetch(`${process.env.REACT_APP_API}/programs/settings`, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            if (result.message !== 'Success') {
                toast.error(result.message);
            }
        } else {
          const response = await fetch(`${process.env.REACT_APP_API}/programs/settings/${formData.id}`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
          });

          const result = await response.json();
          if (result.message !== 'Success') {
            toast.error(result.message);
          }

        }
    } catch (error) {
      console.error('Network error.  Please try again: ', error);
    }
  }
  
  const textFieldStyles = Styles.textFieldStyles;

  useEffect(() => {
    if (setting.id !== undefined) {
      setFormData(setting);      
    } 
  }, [setting]);

  return (
    <>
        { formData.id === "" && 
            <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleOpen}>
                Add New
            </Button>
        }

        { formData.id !== '' && 
          <Button variant="outlined" color="success" size="small" onClick={handleEditOpen}>
              <EditIcon />
          </Button>
        }
        
        <Modal 
          open={open} 
          onClose={handleClose}
          style={{
            overlay: {
              backgroundColor: '#080030', // Semi-transparent black
            },
            content: {
              backgroundColor: '#080030',
            },
          }}
        >
            <Box sx={{color: 'white', p: 4}}>
                <Box
                  component={Paper}
                  elevation={3}
                  sx={{
                    mx: 'auto',
                    width: 400,
                    bgcolor: '#1e1e1e',
                    p: 2,
                  }}
                >
                  {errors.submit && (
                    <Alert severity="error" sx={{ mb: 3 }}>
                      {errors.submit}
                    </Alert>
                  )}
                  <Typography variant="h4" component="h2" color="white" mb={2}>
                    {title}
                  </Typography>

                  <Box component="form" onSubmit={handleUpdate}>
                    <Stack spacing={2}>
                        <TextField
                            fullWidth
                            label="Category"
                            value={formData.category}
                            onChange={handleInputChange('category')}
                            error={!!errors.category}
                            helperText={errors.category}
                            sx={ textFieldStyles }
                        />
                        <TextField
                            fullWidth
                            label="Parameter"
                            value={formData.parameter}
                            onChange={handleInputChange('parameter')}
                            error={!!errors.parameter}
                            helperText={errors.parameter}
                            sx={ textFieldStyles }                        
                        />
                        <TextField
                            fullWidth
                            label="Setting"
                            value={formData.setting}
                            onChange={handleInputChange('setting')}
                            error={!!errors.setting}
                            helperText={errors.setting}
                            sx={ textFieldStyles }
                        />
                        <TextField
                            select
                            fullWidth
                            label="Human Edit"
                            value={formData.human_edit}
                            onChange={handleInputChange('human_edit')}
                            error={!!errors.human_edit}
                            helperText={errors.human_edit}
                            sx={ textFieldStyles }
                        >
                            {options.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                        </TextField>
                        <TextField
                            select
                            fullWidth
                            label="Phen Edit"
                            value={formData.phen_edit}
                            onChange={handleInputChange('phen_edit')}
                            error={!!errors.phen_edit}
                            helperText={errors.phen_edit}
                            sx={ textFieldStyles }
                        >
                            {options.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                  <ButtonGroup 
                    size="small"
                    variant="contained" 
                    aria-label="Basic button group" 
                    fullWidth
                    sx={{ mt:2 }}
                  >
                    <Button
                      onClick={handleClose}
                      type="cancel"
                      variant="contained"
                      sx={ Styles.buttonStyle }
                    >
                      Cancel
                    </Button>              
                    <Button
                      type="submit"                      
                      variant="contained"
                      sx={{ ...Styles.buttonStyle,  ml:4 }}
                      disabled={isFormValid}
                    >
                      {title}
                    </Button>
                  </ButtonGroup>
          </Stack>
        </Box>
    </Box>

</Box>
</Modal>            
    </>
  );
}